import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TUI_VALIDATION_ERRORS, TuiFileLike } from '@taiga-ui/kit';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Observable, Subject, finalize, map, of, switchMap, timer } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MailService } from 'src/app/shared/mail.service';
import { SuccessConfirmComponent } from 'src/app/shared/success-confirm/success-confirm.component';
import { ErrorConfirmComponent } from 'src/app/shared/error-confirm/error-confirm.component';
 


@Component({
  selector: 'app-contatti',
  templateUrl: './contatti.component.html',
  styleUrls: ['./contatti.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContattiComponent implements OnInit {
  isLoading = false; // Variabile per tracciare lo stato di caricamento
  readonly mailwingId = "9c1ec1bc-2e0b-488e-b07f-8a1a7ed81f0c"
  form = new FormGroup({
    name: new FormControl<string | null>(null, [Validators.required]),
    surname: new FormControl<string | null>(null, [Validators.required]),
    email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
    message: new FormControl<string | null>(null, [Validators.required]),
    privacy: new FormControl(false, [Validators.requiredTrue])   

  })


  constructor(private recaptchaV3Service: ReCaptchaV3Service, private mailService: MailService, private modalService: NgbModal, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    window.scrollTo(0,0);

  }

  sendEmail() {
    this.isLoading = true; // Imposta lo stato di caricamento su true
    this.recaptchaV3Service.execute('sendEmail').subscribe(token => {
      console.log(token)
      const formData = new FormData();

      formData.append("name", this.form.controls.name.value as string);
      formData.append("surname", this.form.controls.surname.value as string);
      formData.append("email", this.form.controls.email.value as string);
      formData.append("message", this.form.controls.message.value as string);
      formData.append("g-recaptcha", token);
      formData.append("mailwing_id", this.mailwingId);

      this.mailService.inviaMail(formData).subscribe({
        next: (resp) => {
          this.isLoading = false; // Imposta lo stato di caricamento su false
          this.cdr.detectChanges(); // Forza il rilevamento delle modifiche
          this.modalService.dismissAll()
          this.modalService.open(SuccessConfirmComponent, {
            size: 'lg',
            modalDialogClass: 'signup-modal',
            centered: true,
            
          });
 
          
        },
        error: (error) => {
          this.isLoading = false; // Imposta lo stato di caricamento su false
          this.cdr.detectChanges(); // Forza il rilevamento delle modifiche
          this.modalService.dismissAll()
          this.modalService.open(ErrorConfirmComponent, {
            size: 'lg',
            modalDialogClass: 'signup-modal',
            centered: true,
            
          });
          this.isLoading = false; // Imposta lo stato di caricamento su false

        }
      })


    })
      
    
    
  }
  



}





